import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataDetailViewBuilderComponent } from './data-detail-view-builder.component';
import { DataDetailViewBuilderFieldsComponent } from './data-detail-view-builder-fields/data-detail-view-builder-fields.component';
import { DataDetailViewBuilderSettingsComponent } from './data-detail-view-builder-settings/data-detail-view-builder-settings.component';
import { RappiderModalModule } from '../modal/modal.module';
import { RappiderButtonModule } from '../button/button.module';
import { RappiderSelectModule } from '../select/select.module';
import { RappiderSwitchModule } from '../switch/switch.module';
import { RappiderTextboxModule } from '../textbox/textbox.module';
import { RappiderCrudFieldsDisplayModule } from '../crud-fields-display/crud-fields-display.module';
import { FormsModule } from '@angular/forms';
import { AngularSplitModule } from 'angular-split';
import { RappiderJsonEditorModalModule } from '../json-editor-modal/json-editor-modal.module';
import { RappiderAlertModule } from '../alert/alert.module';
import { RappiderColorPickerModule } from '../color-picker/color-picker.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RappiderFieldFormattingToolbarModule } from '../field-formatting-toolbar/field-formatting-toolbar.module';

@NgModule({
  declarations: [
    DataDetailViewBuilderComponent,
    DataDetailViewBuilderFieldsComponent,
    DataDetailViewBuilderSettingsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RappiderModalModule,
    RappiderButtonModule,
    RappiderSelectModule,
    RappiderSwitchModule,
    RappiderTextboxModule,
    RappiderCrudFieldsDisplayModule,
    AngularSplitModule,
    RappiderJsonEditorModalModule,
    RappiderAlertModule,
    RappiderColorPickerModule,
    RappiderFieldFormattingToolbarModule,
    DragDropModule,
    NzDropDownModule,
    NzMenuModule,
    NzToolTipModule
  ],
  exports: [
    DataDetailViewBuilderComponent
  ]
})
export class DataDetailViewBuilderModule { }

